// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"31d6cfe0","805":"8417c8ec"}[chunkId] + ".chunk.css";
};